export default "__VITE_ASSET__B_Q_mjhh__"